export const truncateString = (string = "", maxLength = 20) =>
  string.length > maxLength ? `${string.substring(0, maxLength)}…` : string;

export const formatNumber = (number) =>
  typeof number === "number" ? new Intl.NumberFormat("en").format(number) : "";
